import { type FC } from 'react';

import { SliderBlock } from 'shared/components/SliderBlock';

import { MedalsCard } from './internal/components/MedalsCard';
import { RatingCard, type TRatingHelp } from './internal/components/RatingCard';
import { RatingsSources, type TRatingSource } from './internal/components/RatingsSources';
type TMedals = Record<'gold' | 'silver' | 'bronze', number>;

type TRating = {
  /** Описание рейтинга **/
  description: string;
  /** Подсказка **/
  help?: TRatingHelp;
  /** URL иконки рейтинга **/
  iconUrl: string;
  /** Значение рейтинга **/
  value: string;
  /** Подпись к значению рейтинга **/
  valueLabel: string;
};

type TRatingsProps = {
  ratingsLabel: string;
  ratingSource: TRatingSource;
  medals: TMedals | undefined;
  ratings: TRating[];
  onView: () => void;
};

export const Ratings: FC<TRatingsProps> = ({ ratingsLabel, ratingSource, medals, ratings, onView }) => {
  return (
    <SliderBlock
      id="ratings"
      sourceLabel={ratingsLabel}
      sourceTooltip={<RatingsSources source={ratingSource} />}
      title="Позиции в рейтингах"
      onShow={onView}
    >
      {ratings.map((rating, index) => (
        <RatingCard
          description={rating.description}
          help={rating.help}
          icon={rating.iconUrl}
          key={index}
          place={rating.value}
          placeLabel={rating.valueLabel}
        />
      ))}
      {medals && <MedalsCard bronze={medals.bronze} gold={medals.gold} silver={medals.silver} />}
    </SliderBlock>
  );
};
